/**
 * <WcLockedNotice mode="..." accent="#FFD700" />
 *
 * Shown in place of gameplay content when a (mode, platform) is hidden by
 * the admin visibility gate. Keeps Register button + rules visible.
 */
import React from "react";
import { Lock, BellRing } from "lucide-react";

export default function WcLockedNotice({ accent = "#FFD700", title, body }) {
  return (
    <div
      data-testid="wc-locked-notice"
      className="rounded-3xl border-2 p-6 text-center space-y-3"
      style={{
        borderColor: `${accent}55`,
        background: `linear-gradient(160deg, ${accent}10 0%, rgba(2,6,23,0.6) 100%)`,
      }}
    >
      <div
        className="w-12 h-12 mx-auto rounded-full flex items-center justify-center"
        style={{ background: `${accent}1a`, border: `1px solid ${accent}55` }}
      >
        <Lock className="w-5 h-5" style={{ color: accent }} />
      </div>
      <div
        className="text-[10px] font-mono uppercase tracking-[0.3em]"
        style={{ color: accent }}
      >
        // Locked
      </div>
      <div className="font-heading text-lg uppercase tracking-wider text-white">
        {title || "Your view will unlock soon"}
      </div>
      <div className="text-[12px] text-white/65 max-w-md mx-auto leading-relaxed">
        {body || (
          <>
            The admin hasn't released this mode yet. You can already register
            your interest above — we'll notify you the moment your team,
            standings or bracket become visible.
          </>
        )}
      </div>
      <div
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10px] font-mono uppercase tracking-widest"
        style={{ background: `${accent}15`, color: accent, border: `1px solid ${accent}33` }}
      >
        <BellRing className="w-3 h-3" /> Watch this page · use Register Now above
      </div>
    </div>
  );
}
